import { cn } from "@utils/tw"
import { ComponentPropsWithoutRef, forwardRef } from "react"

export const ButtonList = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<"div">>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex flex-col mt-8 border-t border-grey pt-3 gap-1",
        "[&_button]:w-full [&_a]:w-full [&_button]:justify-between [&_a]:justify-between",
        "[&_button_span]:max-w-[calc(100%-32px)] [&_button_span]:inline-block [&_button_span]:text-left",
        "[&_a_span]:max-w-[calc(100%-32px)] [&_a_span]:inline-block [&_a_span]:text-left",
        className,
      )}
      {...props}
    />
  ),
)
ButtonList.displayName = "ButtonList"
